import { render, staticRenderFns } from "./c-edit-tag-popup.vue?vue&type=template&id=4345700b&scoped=true"
import script from "./c-edit-tag-popup.vue?vue&type=script&lang=js"
export * from "./c-edit-tag-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345700b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4345700b')) {
      api.createRecord('4345700b', component.options)
    } else {
      api.reload('4345700b', component.options)
    }
    module.hot.accept("./c-edit-tag-popup.vue?vue&type=template&id=4345700b&scoped=true", function () {
      api.rerender('4345700b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/pre-release/popups/c-edit-tag-popup.vue"
export default component.exports